import fetchIntercept from 'fetch-intercept';
 
const registerIntercept = fetchIntercept.register({
    request: function (url, config) {
        // Modify the url or config here
        let configuracion = new Object({});

        if(config == undefined){   
            let headers = new Object({});
            headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
            headers.AuditUser = `${localStorage.getItem('user')}`;
    
            configuracion = {
                headers: headers
            };
        }else{

            if(config.headers != undefined){
                config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
                config.headers.AuditUser = `${localStorage.getItem('user')}`;
            }

            configuracion = config;
        }
        return [url, configuracion];
    },
 
    requestError: function (error) {
        // Called when an error occured during another 'request' interceptor call
        return Promise.reject(error);
    },
 
    response: function (response) {
        // Modify or log the reponse object
        if(response.status  === 401){
            document.location.href = '/';
        }

        return response;
    },
 
    responseError: function (error) {
        // Handle a fetch error
        return Promise.reject(error);
    }
});